export default __webpack_public_path__ + "static/media/worker.ade4af18.png";